export const trackSort = (analytics = { page: {} }, value, sortOptions) => {
    const { page } = analytics;
    const sortSelected = sortOptions?.find((sortOption) => sortOption.value === value) || {};
    return {
        event: 'list page - sort',
        eventEffect: 'update view',
        category: {
            primaryCategory: page?.category?.pageType,
            subCategory: page?.category?.subCategory1,
        },
        attributes: {
            value,
            label: sortSelected.labelEN,
        },
    };
};
